<template>
    <div id="contactUs">
      <div class="contactusContainer">
        <div class="titleContainer">
          {{$t('contactUs.title')}}
        </div>
        <div class="firstTitle">
          {{$t('contactUs.firstTitle')}}
        </div>
        <div class="secondTitle">
          {{$t('contactUs.secoundTitle')}}
        </div>
        <div class="contactusSlider " v-if="staticCard">
          <Loader v-if="!display" />
          <Error v-if="error" />
          <div v-for="(card,i) in info.slider" :key="i">
          <contactus-card :data="card"/>
<!--              <slider-layout />-->
          </div>
        </div>
        <div v-if="slider">
          <slider-layout :data="info" :obj="contactUs" method="get" sliderHolder="contactUs" @transform="slideTransform" @refreshSlider="refreshSliderHandler"/>
          <div class="swipe">
            <img src="../../assets/icons/swipe.svg">
            <div>{{$t('swipe')}}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import SliderLayout from '../../components/sliders/SliderLayout'
import ContactusCard from '../../components/cards/ContactusCard'
import $ from 'jquery'
import ContactUsCardRepository from '../../repositories/ContactUsCardRepository'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
export default {
  name: 'ContactUs',
  components: { ContactusCard, SliderLayout, Loader, Error },
  data () {
    return {
      contactUs: new ContactUsCardRepository(),
      refresh: true,
      show: false,
      error: false,
      display: this.show,
      slider: false,
      staticCard: true,
      info: {
        sliderType: 'cardsMiniSlider',
        main: { sectionId: 'contactUs', cardType: 'contactus', title: '', description: '', image: '' },
        slider: []
      }
    }
  },
  watch: {
    show (val) {
      this.display = val
      this.$forceUpdate()
    },
    error (val) {
      if (val) {
        this.display = true
      }
    }
  },
  mounted () {
    this.arabic()
    this.getData()
    // this.hideSlider()
    window.addEventListener('resize', () => {
      this.hideSlider()
    })
    // this.hideSlider()
  },
  created () {
    // this.getData()
    // this.hideSlider()
  },
  methods: {
    hideSlider () {
      const sliderLength = this.info.slider.length
      // if (window.innerWidth > 1550) {
      //   this.staticCard = true
      //   this.slider = false
      // } else if (window.innerWidth < 1550) {
      //   this.staticCard = false
      //   this.slider = true
      // }
      if (window.innerWidth > 0 && window.innerWidth < 550) {
        if (sliderLength === 1) {
          this.staticCard = true
          this.slider = false
        } else if (sliderLength > 1) {
          this.staticCard = false
          this.slider = true
        }
      } else if (window.innerWidth > 550 && window.innerWidth < 820) {
        if (sliderLength === 2) {
          this.staticCard = true
          this.slider = false
        } else if (sliderLength > 2) {
          this.staticCard = false
          this.slider = true
        }
      } else if (window.innerWidth > 820 && window.innerWidth < 1120) {
        if (sliderLength === 3) {
          this.staticCard = true
          this.slider = false
        } else if (sliderLength > 3) {
          this.staticCard = false
          this.slider = true
        }
      } else if (window.innerWidth > 1120 && window.innerWidth < 1600) {
        if (sliderLength === 4) {
          this.staticCard = true
          this.slider = false
        } else if (sliderLength > 4) {
          this.staticCard = false
          this.slider = true
        }
      } else if (window.innerWidth > 1600) {
        if (sliderLength === 5) {
          this.staticCard = true
          this.slider = false
        } else if (sliderLength > 5) {
          this.staticCard = false
          this.slider = true
        }
      }
    },
    refreshSliderHandler () {
      // Removing my-component from the DOM
      this.refresh = false
      this.$nextTick(() => {
        // Adding the component back in
        this.refresh = true
      })
    },
    slideTransform () {
      this.$emit('transform')
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.titleContainer').css('font-family', 'Mtn-arabic-bold')
        $('.firstTitle, .secondTitle').css('font-family', 'Mtn-arabic-regular')
        $('.firstTitle, .secondTitle').css('direction', 'rtl')
        $('.contactusSlider').css('direction', 'rtl')
        $('#contactUs').addClass('ar')
      } else {
        $('#contactUs').addClass('en')
      }
    },
    async getData () {
      try {
        const response = await this.contactUs.get()
        if (response.status === 200) {
          this.info.slider = []
          for (let i = 0; i < response.data.length; i++) {
            this.info.slider.push(response.data[i])
          }
          this.hideSlider()
          // if (this.info.slider.length > 5) {
          //   this.staticCard = false
          //   this.slider = true
          // }
          this.fetched = true
          this.show = true
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
#contactUs.en {
  background: url("../../assets/images/contact-en.png") #F2F2F2 no-repeat;
}
#contactUs.ar {
  background: url("../../assets/images/contact-ar.png") #F2F2F2 no-repeat right;
}
  .contactusContainer{
    /*margin-top: 180px;*/
    padding: 20px 0;
    //background-image: $--gray-gradient;
    min-height: calc(100vh - (160px + 285.6px)) !important;
  }
.titleContainer{
  color: $--yellow;
  font-size: 26px;
  padding: 10px 10px;
  font-family: Mtn-bold;
}
.firstTitle,
.secondTitle{
  font-family: Mtn-regular;
}
.contactusSlider{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 10px;
  min-height: 400px;
}
/*.sliderDisplay{*/
/*  display: none;*/
/*  !*margin-top: 50px;*!*/
/*  padding: 10px 0px 0px 0;*/
/*  width: 100%;*/
/*}*/
/*@media screen and (max-width: 1550px) {*/
/*  .sliderDisplay{*/
/*    display: block !important;*/
/*  }*/
/*  .cardDisplay{*/
/*    display: none;*/
/*  }*/
/*}*/
#contactUs .swiper-wrapper {
  min-height: 450px !important;
}
#contactUs .current-all{
  bottom: -16px;
}
</style>
